export const transliterateLanguages = [
  { title: "English", id: "en" },
  { title: "मराठी", id: "mr" },
  { title: "ಕನ್ನಡ", id: "kn" },
  { title: "हिंदी", id: "hi" },
];
